import * as React from 'react';
import { useLatestReffable } from './useLatestRef';

export function useToggleable(initialVal: boolean | (() => boolean) = false) {
  const [val, setVal] = React.useState(initialVal);
  const toggle = React.useCallback(() => setVal(!val), [setVal, val]);
  const setTrue = React.useCallback(() => setVal(true), [setVal]);
  const setFalse = React.useCallback(() => setVal(false), [setVal]);
  return useLatestReffable({
    val,
    setVal,
    toggle,
    setTrue,
    setFalse,
  });
}
